export default Object.freeze({
    PERMITTED_LOPI_BINS: [
        520976, 557384, 547133, 520965, 517014,
    ],
});
